import type { Currency, Product } from 'types';

import formatProductVariant from './format-product-variant';

const formatProduct = (productDetails: Product, currency?: Currency) => {
  if (productDetails.variants && productDetails.variants[0]) {
    productDetails.price =
      productDetails.variants[0].price +
      (currency && currency.vat ? productDetails.variants[0].price * currency.vat : 0);
  }
  productDetails.variants = formatProductVariant(productDetails.variants, currency);
  return productDetails;
};

export default formatProduct;
